import { Type } from 'class-transformer';

import { IViewModel } from '../../interfaces/view-model.interface';
import { FolderRoleMember } from './folder-role-member.model';

export class FolderRolePermissionExpression implements IViewModel {
    public id: number;

    public folderPermissionExpressionId: number;

    public roleId: number;
    public roleName: string;
    public roleIsSiteLevel: boolean;

    @Type(() => FolderRoleMember)
    public folderRoleMembers: FolderRoleMember[];

    public canViewFolder: boolean;
    public canCreateFolder: boolean;
    public canDeleteFolder: boolean;
    public canCreateForm: boolean;
    public canDeleteForm: boolean;
    public canGrantPermission: boolean;
    public canManageRoleMembers: boolean;
    public canBuildConstraints: boolean;
    public canBuildWorkflows: boolean;
    public canPublish: boolean;
    public canEditFormTemplateHtml: boolean;
    public canEditSiteHomePageHtml: boolean;
    public canReorderForms: boolean; // Added for VNEXT-1666

    public constructor(folderPermissionExpressionId: number, roleId: number) {
        this.folderPermissionExpressionId = folderPermissionExpressionId;
        this.roleId = roleId;
    }
}
